import dollarIcon from '@iconify/icons-ant-design/dollar-outline';
import homeIcon from '@iconify/icons-ant-design/home-outline';
import percentageIcon from '@iconify/icons-ant-design/percentage-outline';
import { Icon } from '@iconify/react';
import React from 'react';
import { renderToString } from 'react-dom/server';
import { numberWithCommas } from '@/utils/string-utils';
import styled from 'styled-components';

export const customTooltip = (currentChartType, wrapperRef, kpiData) => ({
  intersect: false,
  enabled: false, // disable on canvas tooltip
  custom: (tooltipModel) => {
    // Tooltip Element
    let tooltipEl = document.getElementById('chart-in-kpi-card-tooltip');

    // Create the element on first render, if it does not exist
    if (!tooltipEl) {
      tooltipEl = document.createElement('div');
      tooltipEl.id = 'chart-in-kpi-card-tooltip';
      document.body.appendChild(tooltipEl);
    }

    // Hide if no tooltip
    if (tooltipModel.opacity === 0) {
      tooltipEl.style.opacity = 0;
      return;
    }

    const TooltipBodyWrapper = styled.div`
      height: 100%;
      width: 100%;

      display: flex;
      flex-direction: column;
    `;

    const ItemWrapper = styled.div`
      height: 20px;
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      color: ${({ color }) => color};
    `;

    const IconWrapper = styled.span`
      margin-left: 4px;
      display: flex;
      align-items: center;
    `;

    const ValueWrapper = styled.span`
      margin-left: 4px;
      padding-right: 4px;
      font-size: 12px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
    `;

    const TooltipBodyItem = ({ chartType, kpiDataForTooltipItem }) => {
      const ACTIVE_COLOR = '#ffffff';
      const INACTIVE_COLOR = 'rgba(255, 255, 255, 0.5)';
      const color =
        currentChartType === chartType ? ACTIVE_COLOR : INACTIVE_COLOR;

      const { dataPoints } = kpiDataForTooltipItem;

      const activePointIdx = tooltipModel.dataPoints[0].index;
      const activePointValues = dataPoints[activePointIdx];

      const ItemValues = {
        CURRENT_STR_PROPERTIES: activePointValues.currentStrProperties.value,
        OCCUPANCY: activePointValues.occupancy.value,
        REVENUE: activePointValues.revenue.value,
      };

      const Icons = {
        CURRENT_STR_PROPERTIES: homeIcon,
        OCCUPANCY: percentageIcon,
        REVENUE: dollarIcon,
      };

      return (
        <ItemWrapper color={color}>
          <IconWrapper>
            <Icon icon={Icons[chartType]} width="12px" />
          </IconWrapper>
          <ValueWrapper>
            {numberWithCommas(ItemValues[chartType])}
            {chartType === 'OCCUPANCY' ? '%' : ''}
          </ValueWrapper>
        </ItemWrapper>
      );
    };

    const TooltipBody = () => (
      <TooltipBodyWrapper>
        <TooltipBodyItem
          chartType="CURRENT_STR_PROPERTIES"
          kpiDataForTooltipItem={kpiData}
        />
        <TooltipBodyItem
          chartType="OCCUPANCY"
          kpiDataForTooltipItem={kpiData}
        />
        <TooltipBodyItem chartType="REVENUE" kpiDataForTooltipItem={kpiData} />
      </TooltipBodyWrapper>
    );

    tooltipEl.innerHTML = renderToString(<TooltipBody />);

    // chart canvas position
    const position = wrapperRef.current.getBoundingClientRect();

    // bing's design
    tooltipEl.style.transition = 'all .5s ease';
    tooltipEl.style.opacity = 0.8;
    tooltipEl.style.backgroundColor = '#101938';
    // tooltipEl.style.width = '72px';
    tooltipEl.style.height = '68px';
    tooltipEl.style.position = 'absolute';
    tooltipEl.style.zIndex = 15;
    tooltipEl.style.borderRadius = '4px';
    tooltipEl.style.left = `${position.left + tooltipModel.caretX + 10}px`;
    tooltipEl.style.top = `${position.top + tooltipModel.caretY - 30}px`;
    // eslint-disable-next-line no-underscore-dangle
    tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
    tooltipEl.style.fontSize = `${tooltipModel.bodyFontSize}px`;
    // eslint-disable-next-line no-underscore-dangle
    tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
    tooltipEl.style.padding = `${tooltipModel.yPadding}px  ${tooltipModel.xPadding}px`;
    tooltipEl.style.pointerEvents = 'none';
  },
});
